import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'usuarioNuevoFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									auditar: true, 
									notaDelete: null, 
									tablaPost: ['list_users'],
									tablaDelete: []
								 }
							 }) 
						break;
						case 'inactivarFtn' :							
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									auditar: true, 
									notaDelete: null, 
									tablaPost: ['list_users'],
									tablaDelete: []
								 }
							 }) 
						break;

					}
				}
				await this.save(event.save)

				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'lenteEditarFtn':
							if(this.indexData!==false)
							{
								await this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath]})
							}
							else
							{
								let datos= {}
								datos.list_users = await this.gettersDatalist('list_users', this.dataForm[this.namePath].list_users.name)[0]
								await this.pushDataGet({ data: datos})
							}							
						break;
						case 'inactivarFtn':
							await this.spliceDataGet(this.indexData)
						break;

					}
				}
				const await1 = this.getDataGet({ route: 'get_listusuarios', data: 'usuarios'})
				const await2 = this.resetDataIndex()
				const await3 = this.resetGlobal({state: 'openModal'})
				const await4 = this.resetGlobal({state: 'saveConfig/capa'})
				const await5 = this.resetDataForm()
				await await1
				await await2
				await await3
				await await4
				await await5
			}
			catch{

			}			
		}		
	},
}
